<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">Home</a>
                    <a href="#" class="btn btn-outline-info btn-sm" @click.prevent="addPrinters">Add printer</a>
                </span>
                GESTIONE STAMPANTI
            </div>
        </div>    
        
        <div class="tab-cont" id="style-3">
            <table class="table" >
                <thead class="thead-dark">
                    <tr>
                        <th class="text">Nome</th>
                        <th class="text">Ip</th>
                        <th class="text">Porta</th>
                        <th class="text permessi">Postazioni</th>
                        <th class="text">Elimina stampante</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(printer,i) in printers" :key="printer.id">
                            <td class="text" ><input type="text"  v-model="printer.nome"/></td>
                            <td class="text" ><input type="text"  v-model="printer.ip"/></td>
                            <td class="text" ><input type="text"  v-model="printer.porta"/></td>
                            <td class="text" >
                                <Multiselect
                                    v-model="printer.postazioni"
                                    :options="postazioni"
                                     mode="tags"
                                    :close-on-select="false"
                                />
                            </td>
                            <td>
                                <a href="#" class="btn btn-outline-success btn-large" @click.prevent="action(i,printer._id,printer.nome,printer.ip,printer.porta,printer.postazioni,true)">Salva</a>
                                <a href="#" class="btn btn-outline-warning btn-large" @click.prevent="action(i,printer._id,printer.nome,printer.ip,printer.porta,printer.postazioni)">Elimina</a>
                            </td>
                            
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
</template>

<script>
// @ is an alias to /src
import Multiselect from '@vueform/multiselect'
import { store } from '../store/store.js'
export default {
    components: {
      Multiselect,
    },
  name: 'GestionaleCredenziali',
  data: function () {
            return {
                postazioni:["antipasti","primi","secondi","contorni","pizza","sushi","dolci","frutta","caffe","bevande","amari","cassa","asporto","poke"],
                value: [],
                printers:[],
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    addPrinters() {
        this.printers.push({nome:'',ip:'',porta:'',postazioni:[]})
    },

    displayPrinters() {
        this.axios.post(this.store.path+'displayPrinter',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
           if(response.data.messaggio){
                 response.data.messaggio.forEach(element => {
                  this.printers.push({id:element._id,nome:element.nome, ip:element.ip,porta:element.porta,postazioni:element.postazioni})
            });
            }else{console.log('Non ci sono permessi da mostrare')}

        })
    },
    /** 
     * (i,printer._id,printer.nome,printer.ip,printer.porta,printer.postazioni,true)">Salva</a>
     * (i,printer._id,printer.nome,printer.ip,printer.porta,printer.postazioni)">Elimina</a>
    */
    action(ind,id,nome,ip,porta,postazioni,save) {
        var  path = '';
        if(!save) {
            path='deletePrinter' ;
            this.printers.splice(ind,1)

        }else {
            path = 'creaPrinter'
            //this.utenti.push({nome:nome,password:pw,permessi:permessi});

        }
        this.axios.post(this.store.path+path,{nome:nome,ip:ip,porta:porta,postazioni:postazioni,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
           if(response.data.messaggio){
               console.log(response.data.messaggio)
            }else{console.log('Operazione non riuscita')}

        })
    },
  },
  
  beforeMount() {
      this.displayPrinters();
  },
  
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: column;
}
.nav-sale{
    flex-basis: 15vh;
}

.tab-cont {
    margin: auto;
    margin-top: 20px;
    background: #F5F5F5;
    overflow-y: scroll;
    flex-basis: 80%;
    width: 100vw;
}

#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}
</style>